import React, { Component } from 'react';
import './About.css'
import { Card,  Typography, Divider, Button } from 'antd';
// import { ReactComponent as Icon} from '../../svgs/undraw_add_content_d1tf.svg';
const { Title, Paragraph, Text } = Typography;
let appShot7 = '../../../screenshot7.png'

class About extends Component {

  render() {
    const bg = "https://mdbootstrap.com/img/Photos/Horizontal/Nature/full%20page/img%20%283%29.jpg"
    return (
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <div className="Hero">
          <div className="HeroTitle">
            <Typography>
              <Title style={{color: 'white'}}>Review Your Model's Predictions</Title>
              <Paragraph style={{color: 'white'}}>
                Human in the Loop - Feedback, made easy
              </Paragraph>
              <Button type="primary">See How Now</Button>
            </Typography>
           
            <div className="ShowApp">
              <img style={{margin: 'auto 0'}} src={appShot7} />
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
     
        <br />
        <br />
        <br />
        <div style={{background: 'linear-gradient(#F0F2F5, #8c94eb)'}}>
        
        
          <div>
            <br />
            <Title style={{textAlign: 'center', marginBottom: 16}}>Audit Machine Learning Production Outputs </Title>
            <br />
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <div style={{width: 300, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Title>Evaluate</Title>
                <Paragraph style={{textAlign: 'center'}}>
                  Our UI makes it easy to view the images and predictions your ML model made
                </Paragraph>
              </div>

              <div style={{width: 300, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Title>Update</Title>
                <Paragraph style={{textAlign: 'center'}}>
                  Correct predictions by selecting the correct label next to the image
                </Paragraph>
              </div>

              <div style={{width: 300, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Title>Improve</Title>
                <Paragraph style={{textAlign: 'center'}}>
                  Update models with data it got wrong in production
                </Paragraph>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div>
            <br />
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center',}}>
              <Title>How It Works</Title>
              <Paragraph><b>What We Assume</b></Paragraph>
              
                <p>You have images that have been classified by a ML algorathim</p>
                <p>You have saved the predictions and images to a server or DB</p>
                <p>You have an HTTPS API endpoint that can GET a list of Items that need to be reviewed</p>
                <p>You have an HTTPS API endpoint that can accept the data you want to Update / Save </p>
            
              <br />

              <Paragraph>
                <b>The Setup</b>
              </Paragraph>
              
                <p>Connect Endpoints</p>
                <p>Review Predictions</p>
                <p>Update/Save</p>
                <p>Repeat</p>
              
              <br />

              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center',}}>
                <h3>Connect Endpoint</h3>
                <img src="../../../endpoint1.png"/>
              </div>
            </div>

            <br />
            <br />

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <Title style={{textAlign: 'center'}}>Pricing</Title>
              <Card title="Basic Plan" extra={<p style={{margin: 'auto 0'}}>Free!</p>} style={{ width: 300 }}>
              {/* <Card title="Basic" extra={<a href="#">More</a>} style={{ width: 300 }}> */}
                <p>Our Only Plan!</p>
                <p>Free!</p>
                <p>Connect Endpoints</p>
                <p>View Images & Predictions</p>
              </Card>
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}


export default About;

